import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { MatNavbarModule } from "@obg/mat.ui.core";
import { AccountCreatedUiModule } from "@obg/ngx.ui.common";
import { CompactFooterModule } from "@obg/ngx.ui.core";

import { DepositBonusesModule } from "../../deposit-bonuses/deposit-bonuses.module";
import { BonusSelectionUiModule } from "../bonus-selection.module";

import { WelcomeBonusContainer } from "./welcome-bonus.container";

const DIRECTIVES = [WelcomeBonusContainer];

@NgModule({
	imports: [
		CommonModule,
		AccountCreatedUiModule,
		BonusSelectionUiModule,
		DepositBonusesModule,
		CompactFooterModule,
		MatNavbarModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class WelcomeBonusUiModule {
	constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

	getComponent() {
		return this.componentFactoryResolver.resolveComponentFactory(WelcomeBonusContainer);
	}
}
